import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const EmptyState = ({ icon: Icon, title, description, ctaLabel, ctaTo, onCtaClick, testid = "empty-state" }) => (
  <div
    data-testid={testid}
    className="rounded-2xl border border-dashed border-border/80 bg-card/60 p-12 md:p-16 flex flex-col items-start gap-4"
  >
    {Icon && (
      <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center">
        <Icon size={28} weight="duotone" className="text-primary" />
      </div>
    )}
    <h3 className="font-display text-2xl md:text-3xl font-semibold">{title}</h3>
    <p className="text-muted-foreground max-w-lg leading-relaxed">{description}</p>
    {ctaLabel && onCtaClick && (
      <Button
        onClick={onCtaClick}
        className="rounded-full h-11 px-6 mt-2 font-semibold"
        data-testid={`${testid}-cta`}
      >
        {ctaLabel}
      </Button>
    )}
    {ctaLabel && !onCtaClick && ctaTo && (
      <Link to={ctaTo}>
        <Button className="rounded-full h-11 px-6 mt-2 font-semibold" data-testid={`${testid}-cta`}>
          {ctaLabel}
        </Button>
      </Link>
    )}
  </div>
);